// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconGoogle = ({ width, height, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 59 59"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <circle className="a" fill="#bf1a1a" cx="29.5" cy="29.5" r="29.5" />
      <g transform="translate(19.213 18.887)">
        <path
          className="b"
          fill="#fff"
          d="M10.606,25.713c6.121,0,10.186-4.3,10.186-10.36a9.063,9.063,0,0,0-.173-1.765H10.608v3.646h6.02a5.744,5.744,0,0,1-6.02,4.572,6.7,6.7,0,0,1,0-13.4,5.959,5.959,0,0,1,4.226,1.635l2.879-2.763A10.143,10.143,0,0,0,10.606,4.5a10.606,10.606,0,0,0,0,21.213Z"
          transform="translate(0 -4.5)"
        />
      </g>
    </svg>
  )
}

IconGoogle.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
}

IconGoogle.defaultProps = {
  width: '45px',
  height: '45px',
  onClick: () => {},
}

export default IconGoogle
